import { SortOrder } from "../sort-order";

export class ApplicationSubscriptionFilters {
  name: string;
  description: string;
  subscriptionType: string;
  protocol: string;
  tenantUuids: string[];
  active?: boolean;
  sortField: string;
  sortOrder: SortOrder;
}
